// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription-selection-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 40px 20px;
  overflow-y: auto;
}

.subscription-header {
  text-align: center;
  margin-bottom: 40px;
  color: white;
  position: relative;
}

.back-to-home-btn {
  position: absolute;
  top: 0;
  left: 40px;
  background: rgba(255, 255, 255, 0.15);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.back-to-home-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateX(-2px);
}

.subscription-header h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 12px;
}

.subscription-subtitle {
  font-size: 1.1rem;
  opacity: 0.95;
  max-width: 600px;
  margin: 0 auto 30px;
}

.billing-cycle-toggle {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
}

.cycle-btn {
  padding: 12px 24px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.cycle-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}

.cycle-btn.active {
  background: white;
  color: #667eea;
  border-color: white;
}

.save-badge {
  background: #10b981;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 700;
}

.loading-spinner {
  text-align: center;
  color: white;
  font-size: 1.2rem;
  padding: 100px 20px;
}

.error-message {
  background: #fee2e2;
  border: 1px solid #ef4444;
  color: #991b1b;
  padding: 16px;
  border-radius: 8px;
  margin: 0 auto 24px;
  max-width: 600px;
  text-align: center;
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto 40px;
}

.plan-card {
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  border: 3px solid transparent;
}

.plan-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
}

.plan-card.selected {
  border-color: #667eea;
  box-shadow: 0 15px 40px rgba(102, 126, 234, 0.3);
}

.plan-card.popular {
  border-color: #f59e0b;
}

.popular-badge {
  position: absolute;
  top: -12px;
  right: 24px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.developer-badge {
  position: absolute;
  top: -12px;
  right: 24px;
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.plan-header {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.plan-name {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
}

.plan-price {
  margin-bottom: 12px;
}

.price {
  font-size: 2.5rem;
  font-weight: 800;
  color: #667eea;
  display: block;
}

.price-note {
  font-size: 0.875rem;
  color: #6b7280;
  display: block;
  margin-top: 4px;
}

.plan-description {
  font-size: 0.95rem;
  color: #6b7280;
  line-height: 1.5;
}

.plan-features {
  margin-bottom: 24px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  font-size: 0.95rem;
  color: #374151;
}

.feature-icon {
  font-size: 1.25rem;
  flex-shrink: 0;
}

.additional-features {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.additional-features .feature-icon {
  color: #10b981;
  font-weight: 700;
}

.select-plan-btn {
  width: 100%;
  padding: 14px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.select-plan-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.select-plan-btn.selected {
  background: #10b981;
}

.subscription-actions {
  text-align: center;
  max-width: 500px;
  margin: 0 auto;
}

.continue-btn {
  width: 100%;
  padding: 16px 32px;
  background: white;
  color: #667eea;
  border: 3px solid white;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 16px;
}

.continue-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(255, 255, 255, 0.3);
}

.continue-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.terms-note {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
}

.terms-note a {
  color: rgba(255, 255, 255, 1);
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.2s ease;
}

.terms-note a:hover {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: underline;
}

/* Responsive design */
@media (max-width: 768px) {
  .subscription-header h1 {
    font-size: 2rem;
  }

  .subscription-subtitle {
    font-size: 1rem;
  }

  .plans-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .plan-card {
    padding: 24px;
  }

  .plan-name {
    font-size: 1.5rem;
  }

  .price {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .subscription-selection-container {
    padding: 20px 12px;
  }

  .billing-cycle-toggle {
    flex-direction: column;
    width: 100%;
  }

  .cycle-btn {
    width: 100%;
    justify-content: center;
  }

  .back-to-home-btn {
    position: relative;
    top: auto;
    left: auto;
    margin-bottom: 20px;
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SubscriptionSelection.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,qCAAqC;EACrC,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":[".subscription-selection-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 40px 20px;\n  overflow-y: auto;\n}\n\n.subscription-header {\n  text-align: center;\n  margin-bottom: 40px;\n  color: white;\n  position: relative;\n}\n\n.back-to-home-btn {\n  position: absolute;\n  top: 0;\n  left: 40px;\n  background: rgba(255, 255, 255, 0.15);\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.back-to-home-btn:hover {\n  background: rgba(255, 255, 255, 0.25);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateX(-2px);\n}\n\n.subscription-header h1 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 12px;\n}\n\n.subscription-subtitle {\n  font-size: 1.1rem;\n  opacity: 0.95;\n  max-width: 600px;\n  margin: 0 auto 30px;\n}\n\n.billing-cycle-toggle {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n  margin-top: 24px;\n}\n\n.cycle-btn {\n  padding: 12px 24px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.cycle-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.cycle-btn.active {\n  background: white;\n  color: #667eea;\n  border-color: white;\n}\n\n.save-badge {\n  background: #10b981;\n  color: white;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.loading-spinner {\n  text-align: center;\n  color: white;\n  font-size: 1.2rem;\n  padding: 100px 20px;\n}\n\n.error-message {\n  background: #fee2e2;\n  border: 1px solid #ef4444;\n  color: #991b1b;\n  padding: 16px;\n  border-radius: 8px;\n  margin: 0 auto 24px;\n  max-width: 600px;\n  text-align: center;\n}\n\n.plans-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n  max-width: 1400px;\n  margin: 0 auto 40px;\n}\n\n.plan-card {\n  background: white;\n  border-radius: 16px;\n  padding: 32px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  border: 3px solid transparent;\n}\n\n.plan-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);\n}\n\n.plan-card.selected {\n  border-color: #667eea;\n  box-shadow: 0 15px 40px rgba(102, 126, 234, 0.3);\n}\n\n.plan-card.popular {\n  border-color: #f59e0b;\n}\n\n.popular-badge {\n  position: absolute;\n  top: -12px;\n  right: 24px;\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  padding: 6px 16px;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.developer-badge {\n  position: absolute;\n  top: -12px;\n  right: 24px;\n  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);\n  color: white;\n  padding: 6px 16px;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.plan-header {\n  margin-bottom: 24px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.plan-name {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 12px;\n}\n\n.plan-price {\n  margin-bottom: 12px;\n}\n\n.price {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: #667eea;\n  display: block;\n}\n\n.price-note {\n  font-size: 0.875rem;\n  color: #6b7280;\n  display: block;\n  margin-top: 4px;\n}\n\n.plan-description {\n  font-size: 0.95rem;\n  color: #6b7280;\n  line-height: 1.5;\n}\n\n.plan-features {\n  margin-bottom: 24px;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 0;\n  font-size: 0.95rem;\n  color: #374151;\n}\n\n.feature-icon {\n  font-size: 1.25rem;\n  flex-shrink: 0;\n}\n\n.additional-features {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.additional-features .feature-icon {\n  color: #10b981;\n  font-weight: 700;\n}\n\n.select-plan-btn {\n  width: 100%;\n  padding: 14px 24px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.select-plan-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n}\n\n.select-plan-btn.selected {\n  background: #10b981;\n}\n\n.subscription-actions {\n  text-align: center;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.continue-btn {\n  width: 100%;\n  padding: 16px 32px;\n  background: white;\n  color: #667eea;\n  border: 3px solid white;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: 16px;\n}\n\n.continue-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 30px rgba(255, 255, 255, 0.3);\n}\n\n.continue-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.terms-note {\n  font-size: 0.85rem;\n  color: rgba(255, 255, 255, 0.8);\n  margin: 0;\n}\n\n.terms-note a {\n  color: rgba(255, 255, 255, 1);\n  text-decoration: underline;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.terms-note a:hover {\n  color: rgba(255, 255, 255, 0.9);\n  text-decoration: underline;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .subscription-header h1 {\n    font-size: 2rem;\n  }\n\n  .subscription-subtitle {\n    font-size: 1rem;\n  }\n\n  .plans-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .plan-card {\n    padding: 24px;\n  }\n\n  .plan-name {\n    font-size: 1.5rem;\n  }\n\n  .price {\n    font-size: 2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .subscription-selection-container {\n    padding: 20px 12px;\n  }\n\n  .billing-cycle-toggle {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .cycle-btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .back-to-home-btn {\n    position: relative;\n    top: auto;\n    left: auto;\n    margin-bottom: 20px;\n    width: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
